import React from 'react';
import '../styles/styleNoti.css'

export default function Noti({ message, onClose }) {
  return (
    <div className='z-10 w-full h-full fixed top-1/2 right-1/2 transform translate-x-1/2 -translate-y-1/2 bg-black/30'>
      <div className='fixed top-1/2 right-1/2 transform translate-x-1/2 -translate-y-1/2 flex justify-center items-center'>
        <div className="bg-white/90 p-3 rounded border border-gray-400  animate-slide-down">
          <div className='p-2 mb-5 text-gray-700'>{message}</div>
          <div className='flex justify-end'>
            <button className='bg-blue-500 hover:bg-blue-500/80 text-white rounded py-1 px-5 justify-items-end font' onClick={onClose}>Đóng</button>
          </div>  
        </div>
      </div>
    </div>
  );
}
